import {Box, Group, Stack, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import IconInfoCircle from "../../../../assets/info-circle.svg?react";

export const TruncatedAnswer: React.FC = () => {
    const {t} = useTranslation();
    return (
        <Box
            p="lg"
            ml={42}
            bg="gneis.0"
            style={{borderRadius: "var(--mantine-radius-md)"}}
        >
            <Group wrap="nowrap" align="flex-start" gap="md">
                <IconInfoCircle height="20px" style={{flexShrink: 0}} />
                <Stack gap={4}>
                    <Text fw={700}>
                        {t("error.truncated.title", {
                            defaultValue: "Svaret ble avkortet",
                        })}
                    </Text>
                    <Text size="sm">
                        {t("error.truncated.body", {
                            defaultValue:
                                "Svaret nådde maksimal lengde, så den siste delen mangler. Prøv å dele spørsmålet opp i flere mindre spørsmål.",
                        })}
                    </Text>
                </Stack>
            </Group>
        </Box>
    );
};
